import { AdviseCurrentSupplier } from '../../../../types/advise';
import { baselineExclusions } from './currentSupplierSpend';
import { BaselineAmount } from './BaselineAmount';
import { BaselineFooterFrame } from './BaselineFooterFrame';
import { NotIncludedYet } from './NotIncludedYet';

/** The supplier's baseline exactly as upstack_api calculated it, so it always matches the card, the step's total and ROI. */
export const InvoiceBaselineFooter = ({ supplier }: { supplier: AdviseCurrentSupplier }) => (
  <BaselineFooterFrame excluded={baselineExclusions(supplier.out_of_scope_amount, supplier.taxes_excluded_amount)}>
    {supplier.complete ? <BaselineAmount supplier={supplier} /> : <NotIncludedYet />}
  </BaselineFooterFrame>
);
